import { EOpenedChatsTypes, TAddOpenedChatPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const addOpenedChat = actionGenerator<EOpenedChatsTypes.Add, TAddOpenedChatPayload>(EOpenedChatsTypes.Add);
export const clearOpenedChats = actionGenerator<EOpenedChatsTypes.Clear>(EOpenedChatsTypes.Clear);
export const deleteOpenedChat = actionGenerator<EOpenedChatsTypes.Delete, string>(EOpenedChatsTypes.Delete);
